var render = function render(){var _vm=this,_c=_vm._self._c;return _c('WmsReport',{ref:_vm.wmsReport,attrs:{"type":"MDPDJL","tableHead":_vm.tableHead,"reportConditionVos":_vm.reportConditionVos}})
}
var staticRenderFns = []

export { render, staticRenderFns }